import React from "react";
import MilitaryField from "@features/port-security/components/occupation-info/MilitaryField.tsx";
import AcademicData from "@features/port-security/components/personal-info/AcademicData";
import BioData from "@features/port-security/components/personal-info/BioData";
import PassportData from "@features/port-security/components/personal-info/PassportData";
import ResidenceData from "@features/port-security/components/personal-info/ResidenceData";
import SponsorData from "@features/port-security/components/personal-info/SponsorData";
import EmiratesIdData from "./EmiratesIdData";

const PersonalInfoForm: React.FC = () => {
  return (
    <div data-testid="personal-info-form" className="flex flex-col gap-8">
      <BioData />
      <MilitaryField />
      <SponsorData />
      <PassportData />
      <EmiratesIdData />
      <ResidenceData />
      <AcademicData />
    </div>
  );
};

export default PersonalInfoForm;
